val flavor: Flavor = ProdFlavor()